export const transformError = (error) => {
  let err = error;
  if (error?.response?.data) {
    err = error.response.data;
    if (Array.isArray(err)) {
      [err] = err;
    }
  }
  return err;
};

export const generateQueryParams = (params) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      queryParams.append(key, value);
    }
  });

  return `?${queryParams.toString()}`;
};
